import script from "./BaseAbility.vue?vue&type=script&lang=ts&setup=true&name=BaseAbility"
export * from "./BaseAbility.vue?vue&type=script&lang=ts&setup=true&name=BaseAbility"

import "./BaseAbility.vue?vue&type=style&index=0&id=a4fcf300&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4fcf300"]])

export default __exports__